/* =========================================================
   KOTMO · kotmo-cart-prix.js
   ========================================================= */
(function () {
  'use strict';

  const KOTMO_UNIT_PROP = '_kotmo_prix_unitaire';
  const KOTMO_FEE_PROP = '_kotmo_frais_montage';
  const DRAFT_ORDER_ENDPOINT = '/apps/kotmo';

  const fmtCAD = (dollars) => new Intl.NumberFormat('fr-CA', {
    style: 'currency', currency: 'CAD', minimumFractionDigits: 2
  }).format(dollars);

  let isApplying = false;

  const getCart = async () => {
    const res = await fetch('/cart.js');
    return res.json();
  };

  const hasKotmoItems = (cart) =>
    cart.items.some(item => item.properties?.[KOTMO_UNIT_PROP]);

  const applyPriceOverrides = async () => {
    if (isApplying) return;
    isApplying = true;

    try {
      const cart = await getCart();
      if (!hasKotmoItems(cart)) return;

      let kotmoSubtotal = 0;
      let nativeSubtotal = 0;
      let totalSetupFee = 0;

      cart.items.forEach((item, index) => {
        const itemEl = document.querySelector(`#CartItem-${index + 1}`);
        const unitPriceStr = item.properties?.[KOTMO_UNIT_PROP];

        if (!unitPriceStr) {
          nativeSubtotal += item.final_line_price / 100;
          return;
        }

        const unitPrice = parseFloat(unitPriceStr);
        const lineTotal = unitPrice * item.quantity;
        kotmoSubtotal += lineTotal;

        const feeStr = item.properties?.[KOTMO_FEE_PROP];
        if (feeStr) totalSetupFee += parseFloat(feeStr);

        if (!itemEl) return;

        // Tous les éléments de prix unitaire
        const allPrices = itemEl.querySelectorAll('.cart-item__price');
        allPrices.forEach(el => { el.textContent = fmtCAD(unitPrice); });

        // Prix total ligne — cart drawer
        const drawerLineTotal = itemEl.querySelector('.cart-item__actions--price');
        if (drawerLineTotal) drawerLineTotal.textContent = fmtCAD(lineTotal);

        // Prix total ligne — cart page
        const pageLineTotal = itemEl.querySelector('.cart-item__total-price');
        if (pageLineTotal) pageLineTotal.textContent = fmtCAD(lineTotal);
      });

      // Sous-total incluant frais de montage
      const trueTotal = kotmoSubtotal + nativeSubtotal + totalSetupFee;

      // Cart drawer
      const drawerTotal = document.querySelector('.cart-drawer__total-price');
      if (drawerTotal) drawerTotal.textContent = fmtCAD(trueTotal);

      // Cart page
      const pageTotal = document.querySelector('.cart__summary-total-price');
      if (pageTotal) pageTotal.textContent = fmtCAD(trueTotal);

      // Note frais de montage — juste sous "Sous-total" (plus mentionnee comme separee/facturee a part)
      document.getElementById('kotmo-fee-note')?.remove();
      if (totalSetupFee > 0) {
        const feeNote = document.createElement('p');
        feeNote.id = 'kotmo-fee-note';
        feeNote.className = 'kotmo-fee-note';
        feeNote.textContent = `Inclus ${fmtCAD(totalSetupFee)} de frais de montage`;

        const totalHeadingEl = document.querySelector('.cart-drawer__summary-total, .cart__summary-total');
        if (totalHeadingEl) totalHeadingEl.insertAdjacentElement('afterend', feeNote);
      }

      interceptCheckout(cart);

    } catch (e) {
      console.error('[Kotmo] Cart override error:', e);
    } finally {
      isApplying = false;
    }
  };

  const interceptCheckout = (cart) => {
    if (!hasKotmoItems(cart)) return;

    // Intercepter le clic direct sur les boutons checkout
    document.querySelectorAll('button[name="checkout"]').forEach(btn => {
      if (btn.dataset.kotmoIntercepted) return;
      btn.dataset.kotmoIntercepted = '1';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        let currentCart;
        try { currentCart = await getCart(); } catch { return; }
        if (!hasKotmoItems(currentCart)) return;

        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Chargement…';

        try {
          const res = await fetch(DRAFT_ORDER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'draft-order', cart: currentCart }),
          });

          if (!res.ok) throw new Error(`Draft order error: ${res.status}`);

          const { url, error } = await res.json();
          if (error) throw new Error(error);
          if (!url) throw new Error('No checkout URL returned');

          window.location.href = url;

        } catch (err) {
          console.error('[Kotmo] Checkout error:', err);
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Une erreur est survenue. Veuillez réessayer.');
        }
      }, { capture: true });
    });
  };

  const observe = () => {
    const targets = [
      document.querySelector('#CartDrawer-Body'),
      document.querySelector('#main-cart-items'),
      document.querySelector('cart-items'),
    ].filter(Boolean);

    if (!targets.length) return;

    const observer = new MutationObserver(() => {
      setTimeout(applyPriceOverrides, 100);
    });

    targets.forEach(target => {
      observer.observe(target, { childList: true, subtree: false });
    });
  };

  const init = () => {
    observe();
    applyPriceOverrides();
    window.addEventListener('load', applyPriceOverrides);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('kotmo:cart-updated', () => {
    setTimeout(applyPriceOverrides, 200);
  });

})();